import template from './sidemenu-submenu.html';

let sidemenuSubmenuComponent = {
//    restrict: 'E',
    bindings: {
    },
    replace: true,
    transclude: true,
    template: template,
    controller: function() {},
    require: {
        itemCtrl: '^sidemenuItem'
    }
};

export default sidemenuSubmenuComponent;
